export const PhoneNumbersPageExceptions = {
  fiwebshop: {
    callNumber1: {
      description: '',
      link: 'tel:+35810191923',
      visual: '010 19 19 23'
    }
  },
  ksb: {
    callNumber1: {
      description: 'Kundeservice',
      visual: '62 51 65 31',
      link: 'tel:+4762516531',
    },
    callNumber2: {
      description: 'Gjelder det en skade? Ring oss på:',
      visual: '21 49 24 00',
      link: 'tel:+4721492400',
    },
  },
  nocomvertikal: {
    callNumber1: {
      description: '',
      visual: '23 01 48 00',
      link: '+4723014800',
    }
  },
  seanimal: {
    callNumber1: {
      description: '',
      visual: '0770-117 177',
      link: '+46770117177',
    }
  },
  sebreeders: {
    callNumber1: {
      description: '',
      visual: '0770-115 000',
      link: '+46770115000',
    }
  },
  dkpriv: {}, // find defaults
  dkkvalitet: {}, // find defaults
  dkwebshop: {}, // find defaults
}